import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-5 flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VueMultiselect, {
      modelValue:  _ctx.userAutocomplete.selection,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (( _ctx.userAutocomplete.selection) = $event)),
      options: _ctx.userAutocomplete.options,
      placeholder: "Scegli utente",
      class: "next-vue-multiselect-single",
      "track-by": "id",
      label: "email",
      selectLabel: "",
      deselectLabel: "",
      selectedLabel: "",
      "internal-search": false,
      onSearchChange: _ctx.userAutocomplete.search
    }, null, 8, ["modelValue", "options", "onSearchChange"]),
    _createVNode(_component_NextButton, { onClick: _ctx.send }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [
        _createTextVNode("invia")
      ])),
      _: 1
    }, 8, ["onClick"])
  ]))
}